import { render, staticRenderFns } from "./thirdStep.vue?vue&type=template&id=27c4c3be&scoped=true&"
import script from "./thirdStep.vue?vue&type=script&lang=js&"
export * from "./thirdStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c4c3be",
  null
  
)

export default component.exports